import { CityResponseData } from "types/city.data"

export const cityResponseData: CityResponseData = {
  label: "Milano",
  slug: "it/milano",
}
